import { render, staticRenderFns } from "./FollowupPanel.vue?vue&type=template&id=7bed483e&scoped=true"
import script from "./FollowupPanel.vue?vue&type=script&lang=js"
export * from "./FollowupPanel.vue?vue&type=script&lang=js"
import style0 from "./FollowupPanel.vue?vue&type=style&index=0&id=7bed483e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed483e",
  null
  
)

export default component.exports